import React from 'react'
import { useTranslation } from 'react-i18next'
import {Col, Row} from 'antd'
import {observer} from 'mobx-react'
import {useInjection} from 'dna-react-ioc'

import {PageContainer, PaymentMethodCard} from '@/components'
import {withTitle} from '@/router/utils'
import {TPaymentMethodsStore} from '@/pages/payment-methods/PaymentMethods/TPaymentMethodsStore'

export const PaymentMethodsStoreSymbol = Symbol('PaymentMethodsStore')
export const PaymentMethodsActivateTerminalSymbol = Symbol('PaymentMethodsActivateTerminalStore')
export const PaymentMethodsApplePayStoreSymbol = Symbol('PaymentMethodsApplePayStore')
export const PaymentMethodsPayByBankAppStoreSymbol = Symbol('PaymentMethodsPayByBankAppStore')
export const PaymentMethodsPaypalStoreSymbol = Symbol('PaymentMethodsPaypalStore')
export const PaymentMethodsOpenBankingStoreSymbol = Symbol('PaymentMethodsOpenBankingStore')
export const PaymentMethodsGooglePayStoreSymbol = Symbol('PaymentMethodsGooglePayStore')
export const PaymentMethodsKlarnaStoreSymbol = Symbol('PaymentMethodsGooglePayStore')

const PaymentMethods = observer(() => {
    const { t } = useTranslation()
    const store = useInjection<TPaymentMethodsStore>(PaymentMethodsStoreSymbol)

    return (
        <PageContainer onBack={store.onBack} title={t('PaymentMethods.title')} isLoading={false}>
            <Row gutter={[16, 16]}>
                {store.paymentMethods?.map((paymentMethod) => (
                    <Col xs={24} sm={12} md={12} lg={8} key={paymentMethod.type}>
                        <PaymentMethodCard
                            title={paymentMethod.title}
                            type={paymentMethod.type}
                            link={paymentMethod.link}
                            linkText={paymentMethod.linkText}
                            onClick={paymentMethod.onClick}
                        />
                    </Col>
                ))}
            </Row>
        </PageContainer>
    )
})

export default withTitle(PaymentMethods)
